import { downloadFile } from '@mi-front/core';
import {
  buildAuditMediaFileUrl,
  resolveAuditMediaIdByCustomId,
} from '../helpers/build-audit-media-file-url';

// This file previously contained Redux thunk actions that have been migrated to hooks.
// See: apps/app/src/modules/audit/modules/station-audit/hooks/useAuditPlayback.ts

/**
 * Resolves media by customId then starts a forced download (attachment response).
 */
export async function auditDownloadAudio(p: { stationId: string; customId: string }) {
  const mediaId = await resolveAuditMediaIdByCustomId(p.stationId, p.customId);
  if (!mediaId) {
    return;
  }

  downloadFile(buildAuditMediaFileUrl(mediaId, { download: true }), false);
}
